import PageHero from "@/components/PageHero";
import CTASection from "@/sections/CTASection";
import { TEAM } from "@/data/team";
import { motion } from "framer-motion";

const HERO_IMG = "https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?w=2400";

export default function Leadership() {
  return (
    <div data-testid="leadership-page">
      <PageHero
        overline="Leadership"
        title={<>The people who<br /><span className="italic font-light text-gold">engineer NEPHRC.</span></>}
        subtitle="A senior team of engineers, architects, consultants and project managers — each with global standards and deep regional fluency."
        image={HERO_IMG}
        breadcrumbs={[{ label: "Leadership" }]}
      />

      <section className="bg-white py-24 sm:py-32">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
            {TEAM.map((m, i) => (
              <motion.div
                key={m.name}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                className="bg-white group cursor-default"
                data-testid={`team-card-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={m.photo} alt={m.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {m.isFounder && (
                    <div className="absolute top-4 left-4 px-3 py-1 bg-gold text-navy text-[10px] font-semibold tracking-widest uppercase">
                      Founder
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-lg text-navy leading-tight">{m.name}</h3>
                  <div className="overline text-emerald-brand mt-2">{m.role}</div>
                  <div className="mt-4 space-y-1 text-xs text-slate-brand">
                    {/* <div><span className="text-slate-400">Qualifications:</span> {m.qualifications}</div> */}
                    <div><span className="text-slate-700">Experience:</span> {m.experience}</div>
                    <div><span className="text-slate-700">Specialisation:</span> {m.spec}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
